/**
 * 接口文档
 * http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/6644be0ceef4bc6c755ed2dc14102a4f
 */
export default {
  /** 作废入库单 */
  cancelOrder: '/api/inbounds/cancel',
  /** 入库单列表 */
  warehousingList: '/api/inbounds/search',
  /** 入库单商品分页列表 */
  goodsListDetail: '/api/inbounds/detail',
  /** 入库单基础信息详情 */
  baseInfo: '/api/inbounds/get',
  /** 创建入库单 */
  create: '/api/inbounds/create',
  /** 编辑个人入库单 */
  edit: '/api/inbounds/update',
  /** 获取打印单详情 */
  getOrder: '/api/inbounds/label-info',
  /** 获取出货配置 */
  getOutboundsSetting: '/api/sales/outbounds/setting/get',
  /** 更新出货配置 */
  updateOutboundsSetting: '/api/sales/outbounds/setting/update',
  /** 计算保险金额 */
  calcInsurance: '/api/sales/outbounds/calculate-insurance',
  /** 更新自动翻译商品名设置 */
  updateTranslationSetting: '/api/settings/updateTranslateSetting',
  /** 获取用户关联的仓库信息 */
  warehouse: '/api/warehouse-grants/list',
  /**标记已完成 */
  complete: '/api/inbounds/manual-complete',
  /** 自动同步的规则检测  */
  settingCheck: '/api/stock/sync/setting/check',
  /** 更新国际条码 */
  updateBarcode: '/api/skus/update-barcode',
  /** 下载入库单接口 */
  getLabelUrl: '/api/inbounds/label-url',
  /**批量作废入库单 */
  bathchCancelUrl: '/api/inbounds/batch-cancel',
}
